import { SmsDirection } from "generated/graphql";
import React from "react";
import { breakNewlines } from "util/text";

interface SmsConversationMessage {
    id: string;
    body: string;
    direction: SmsDirection | string;
    dateAdded: string;
    createdByUser?: {
        id: string;
        displayName: string;
    } | null;
}

interface SmsConversationHistoryProps {
    messages: SmsConversationMessage[];
    showSenderName?: boolean;
}

export const SmsConversationHistory: React.FC<SmsConversationHistoryProps> = props => {
    const { messages, showSenderName } = props;

    if (messages.length === 0) {
        return <div className="text-sm text-gray-500">No messages yet</div>;
    }

    return (
        <div className="flex flex-col space-y-2">
            {messages.map(message => (
                <div
                    key={message.id}
                    className={`flex ${
                        message.direction === SmsDirection.Inbound
                            ? "justify-start"
                            : "justify-end"
                    }`}>
                    <div
                        className={`max-w-[70%] rounded-lg px-4 py-2 ${
                            message.direction === SmsDirection.Inbound
                                ? "bg-gray-100 text-gray-900"
                                : "bg-blue-500 text-white"
                        }`}>
                        <div className="text-sm">{breakNewlines(message.body)}</div>
                        <div
                            className={`text-xs mt-1 ${
                                message.direction === SmsDirection.Inbound
                                    ? "text-gray-500"
                                    : "text-blue-100"
                            }`}>
                            {new Date(message.dateAdded).toLocaleDateString()}{" "}
                            {new Date(message.dateAdded).toLocaleTimeString()}
                            {showSenderName &&
                                message.direction !== SmsDirection.Inbound &&
                                message.createdByUser && (
                                    <span className="ml-2">
                                        &middot; {message.createdByUser.displayName}
                                    </span>
                                )}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};
